import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h16v16H0z" }));
const ForwardRef = forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
